import makeRoutes from "@/routes/Base/Route";

export default [
    ...makeRoutes('interopera').map(route => {
        return {
            ...route,
            meta: {permission: route.name}
        }
    })
]